const tagViews = {
  state: {
    // 用户访问过的页面 就是标签栏导航显示的一个个 tag 数组集合
    viewTagList: [],
    maxTagNum: null,
  },
  mutations: {
    // 设置最大页签数
    SET_MAX_NUM: (state, num) => {
      // state.maxTagNum = num;
    },
    // 新增/替换页签
    ADD_VIEWS_TAGS: (state, view) => {
      if (state.viewTagList.some((v) => v.path === view.path)) return;
      let sameIndex = null;
      state.viewTagList.forEach((el, index) => {
        if (el.path == view.path) {
          sameIndex = index;
        }
      });
      if (sameIndex != null) {
        state.viewTagList.splice(sameIndex, 1, view);
      } else {
        if (
          !state.viewTagList.length ||
            !state.maxTagNum ||
            state.viewTagList.length < state.maxTagNum
        ) {
          state.viewTagList.push(view);
        } else {
          state.viewTagList.splice(0, 1);
          state.viewTagList.push(view);
        }
      }
    },
    // 删除一个页签
    DEL_VIEWS_TAGS: (state, view, index) => {
      let tagIndex = index != undefined ? index : null;
      if (tagIndex == null) {
        state.viewTagList.forEach((el, index) => {
          if (el.path == view.path) {
            tagIndex = index;
          }
        });
      }
      console.log(tagIndex);
      state.viewTagList.splice(tagIndex, 1);
      console.log(state.viewTagList);
      // state.viewTagList.splice(tagIndex, 1);
    },
    // 删除其他所有标签
    DEL_OTHER_VIEW_TAGS: (state, view) => {
      let viewTagList = state.viewTagList.filter((item) => {
        return item.path == view.path;
      });
      state.viewTagList = viewTagList;
    },
    /**删除 除第一个tag外的其他标签 */
    CLEAR_TAGS: (state) => {
      // state.viewTagList = [];
      let viewTagList = state.viewTagList.filter((item, index) => {
        return index == 0;
      });
      state.viewTagList = viewTagList;
    },
  },
  actions: {
    setMaxTagNum({ commit }, num) {
      commit("SET_MAX_NUM", num);
    },
    // 新增当前路由标签和标签缓存
    addViewTag({ commit }, view) {
      commit("ADD_VIEWS_TAGS", view);
    },
    // 点关闭按钮删除一个顶部页签
    delViewTag({ commit }, view) {
      commit("DEL_VIEWS_TAGS", view);
    },
    // 关闭其他所有页签
    delOtherViewTag({ commit }, view) {
      commit("DEL_OTHER_VIEW_TAGS", view);
    },
  },
};
export default tagViews;
